// extracted by mini-css-extract-plugin
export default {"reactChatContainer":"ReactChat-module__reactChatContainer--_snGB"};